import { AbstractControl, ValidationErrors } from '@angular/forms';

const birthDateRegex = /^\d{4}-\d{2}-\d{2}$/;

const BirthDateValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const birthDate = !birthDateRegex.test(value);

  if (!birthDate) {
    return {};
  }

  return { birthDate };
};

export default BirthDateValidator;
